import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../../constants/common'
import {
  APPLICANT_STAGE,
  getRentalPortalApplicantIdentityLabel,
} from '../../../../RentalPortalApplicant'
import { getApplicantTransition } from '../RentalPortalApplicantProfileTabOverview.utils'

import {
  APPLICANT_DECISION_ACTION,
  APPLICANT_DECISION_CONFIRM_TEXT_KEY,
  APPLICANT_DECISION_CONFLICT_KEY,
  APPLICANT_DECISION_PRIMARY_ACTIONS,
  APPLICANT_DECISION_RESELECT_NOTIFICATION_ID,
  APPLICANT_DECISION_TRANSITION_KEY,
} from './ApplicantDecisionPanel.constants'

export function getIsApplicantFourEyesRequired(applicantData) {
  return applicantData?.policy?.four_eyes_required
}

export function getIsApplicantSelectionRejected(applicantData) {
  return Boolean(applicantData?.rejected_at)
}

export function getIsApplicantSelectedStage(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.selected
}

export function getIsApplicantScreeningStage(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.screening
}

export function getIsApplicantDecisionAwaiting(applicantData) {
  return (
    getIsApplicantSelectedStage(applicantData) &&
    !applicantData.approved_by &&
    !getIsApplicantSelectionRejected(applicantData)
  )
}

export function getIsApplicantDecisionSelfApproval({
  applicantData,
  currentUserId,
}) {
  return (
    getIsApplicantFourEyesRequired(applicantData) &&
    currentUserId != null &&
    applicantData?.selected_by_user_id === currentUserId
  )
}

export function getIsApplicantDecisionSelectAction(action) {
  return action === APPLICANT_DECISION_ACTION.select
}

export function getIsApplicantDecisionPrimaryAction(action) {
  return APPLICANT_DECISION_PRIMARY_ACTIONS.includes(action)
}

export function getIsApplicantDecisionReasonRequired(action) {
  return action === APPLICANT_DECISION_ACTION.rejectSelection
}

export function getIsApplicantDecisionUserIconsShown() {
  return false
}

export function getIsApplicantDecisionConflictCurrent({
  applicantId,
  conflict,
}) {
  return conflict?.applicantId === applicantId
}

export function getApplicantDecisionTransition({ action, applicantData }) {
  return getApplicantTransition({
    applicantData,
    key: APPLICANT_DECISION_TRANSITION_KEY[action],
  })
}

export function getApplicantDecisionEligibleCount(applicantData) {
  return applicantData?.eligible_reviewer_count ?? null
}

export function getApplicantDecisionConfirmText({ action, applicantData, t }) {
  return t(APPLICANT_DECISION_CONFIRM_TEXT_KEY[action], {
    applicant: getRentalPortalApplicantIdentityLabel({
      applicant: applicantData,
      t,
    }),
  })
}

export function getApplicantDecisionModalNotifications({ action, t }) {
  return getIsApplicantDecisionSelectAction(action)
    ? [
        {
          id: APPLICANT_DECISION_RESELECT_NOTIFICATION_ID,
          text: t('RentalPortal.ApplicantDecisionReselectHintKey'),
          type: NOTIFICATION_TYPE.info,
        },
      ]
    : EMPTY_LIST
}

export function getApplicantDecisionCurrentConflictKey({
  applicantId,
  conflict,
}) {
  return getIsApplicantDecisionConflictCurrent({ applicantId, conflict })
    ? conflict.key
    : null
}

export function getApplicantDecisionConflictKey(error) {
  return (
    APPLICANT_DECISION_CONFLICT_KEY[error.response.data?.meta?.reason] ??
    'RentalPortal.ApplicantDecisionConflictKey'
  )
}
